import type { ReactNode } from "react";

export const TTDDialogPanels = ({ children }: { children: ReactNode }) => {
  return <div className="ttd-dialog-panels">{children}</div>;
};
